import React, { useContext, createContext, type ReactNode } from 'react';
import type { NavigationTheme } from '../../types.tsx';

type ThemeProviderProps = {
	children?: ReactNode;
	theme: NavigationTheme;
};

const ThemeContext = createContext<NavigationTheme | null>(null);

export const SidebarThemeProvider = ({
	theme,
	children,
}: ThemeProviderProps): React.JSX.Element => (
	<ThemeContext.Provider value={theme}>{children}</ThemeContext.Provider>
);

export const useSidebarTheme = () => useContext(ThemeContext);
